import { inject, Injectable } from "@angular/core";
import type { Translation } from "@jsverse/transloco";
import { TranslocoService } from "@jsverse/transloco";
import { isDefined } from "@recursyve/nice-ts-utils";
import type { Observable } from "rxjs";

@Injectable({
    providedIn: "root"
})
export class LanguagePreloadService {
    private readonly translocoService = inject(TranslocoService);

    public preload(): Observable<Translation> {
        const browserLanguage = this.getBrowserLanguage();
        const activeLanguage = this.getActiveSupportedLanguage(browserLanguage);
        this.translocoService.setActiveLang(activeLanguage);
        return this.translocoService.load(activeLanguage);
    }

    private getActiveSupportedLanguage(activeLanguage: string): string {
        const isSupportedLanguage = this.translocoService.isLang(activeLanguage);
        if (isSupportedLanguage) {
            return activeLanguage;
        }

        return this.translocoService.getDefaultLang();
    }

    private getBrowserLanguage(): string {
        const browserLanguage = localStorage.getItem("lang");
        if (isDefined(browserLanguage)) {
            return browserLanguage;
        }

        return this.translocoService.getDefaultLang();
    }
}
